module.exports = __webpack_public_path__ + "img/comorbidades.1c494b80.png";